import { Box, Stack, Typography } from "@mui/material";
import { FormattedMessage } from "react-intl";

type OrganizationUnitCardRowProps = {
  label: string;
  value?: React.ReactNode;
};
const OrganizationUnitCardRow = ({
  label,
  value,
}: OrganizationUnitCardRowProps) => {
  if (!value) {
    return null;
  }
  return (
    <Stack direction="row" spacing={2}>
      <Box sx={{ width: '40%' }}>
        <Typography variant="body2">
          <FormattedMessage id={label} />
        </Typography>
      </Box>
      <Box sx={{ width: '60%' }}>
        <Typography
          sx={{ wordBreak: "break-word" }}
          color="common.black"
          variant="body2"
        >
          {value}
        </Typography>
      </Box>
    </Stack>
  );
};

export default OrganizationUnitCardRow;
